export default "__VITE_ASSET__BsJOTAkW__"